import React, { useState } from 'react';

const LOADING_IMAGE = '/images/loading-car.gif';

/**
 * LoadingCar - Shows a looping gif for loading states.
 * Place your gif at public/images/loading-car.gif (GIFs loop by default).
 * Falls back to the CSS-drawn car if the image is missing or fails to load.
 */
export function LoadingCar({ className = '' }) {
  const [useFallback, setUseFallback] = useState(false);

  if (useFallback) {
    return (
      <div className={`simple-car-loader ${className}`.trim()}>
        <div className="simple-car">
          <div className="simple-car-body"></div>
          <div className="simple-car-top"></div>
          <div className="simple-car-window"></div>
          <div className="simple-car-light-front"></div>
          <div className="simple-car-light-back"></div>
          <div className="simple-car-wheel simple-car-wheel-front"></div>
          <div className="simple-car-wheel simple-car-wheel-back"></div>
          <div className="speed-lines">
            <div className="speed-line"></div>
            <div className="speed-line"></div>
            <div className="speed-line"></div>
          </div>
          <div className="exhaust">
            <div className="exhaust-puff"></div>
            <div className="exhaust-puff"></div>
            <div className="exhaust-puff"></div>
          </div>
        </div>
        <div className="simple-road"></div>
      </div>
    );
  }

  return (
    <div className={`simple-car-loader loading-car-gif-wrap ${className}`.trim()}>
      <img
        src={LOADING_IMAGE}
        alt="Loading"
        className="loading-car-gif"
        onError={() => setUseFallback(true)}
      />
      <div className="simple-road"></div>
    </div>
  );
}

export default LoadingCar;
